// extracted by mini-css-extract-plugin
module.exports = {"header-group":"header-group--20Svp","title":"title--qViv8","buttons":"buttons--2FSRn"};